export const title = "CF Global";
export const registered = {
    accountType: "Tài khoản thật",
    accountTitle: "Đăng ký Tài khoản",
    registered: "Đăng ký ngay",
    explain: "Tôi đã đủ 18 tuổi và đồng ý Điều khoản riêng tư của TREX",
    successTitle: "Đăng ký thành công",
    successTxt: "Bạn có thể đăng nhập vào Trung tâm khách hàng để kích hoạt tài khoản TREX và MT4",
    goPosition: "Giao dịch",
    questionTit: "Làm thể nào để nhận Bonus?",
    questionStep1: "Bước 1",
    questionTxt1: "Đăng nhập tài khoản",
    questionStep2: "Bước 2",
    questionStep3: "Bước 3",
    questionTxt3: "Liên hệ CSKH và nhận Bonus",
    questionStep4: "Bước 4",
    questionTxt4: "Giao dịch nhận Bonus",
    invalidTxt: "Xin nhập vào số điện thoại chính xác",
    invalidPwdTxt1: "Không thể trống !",
    invalidPwdTxt2: "Mật khẩu có 5-15 ký tự, bao gồm cả chữ cái và chữ số !",
};
export const login = {
    language: 'Ngôn ngữ',
    account: 'Số điện của bạn',
    password: 'Mật khẩu',
    accountPlace: 'Nhập số tài khoản GD/ Số ĐT',
    passwordPlace: 'Vui lòng nhập mật khẩu',
    submit: 'Đăng nhập',
    rigister: 'Chưa có tài khoản?',
    forget: 'Quên mật khẩu',
    openAcc: "Đăng ký",
    logging: 'Đang đăng nhập',
    accountNull: 'Tài khoản khách hàng của bạn là không',
    pwNull: "Mật khẩu của bạn là không",
    goLogin: 'Đi đăng nhập',
    openAccount: 'Đăng ký ngay',
    countrySearch: 'Tên nhà nước/ Mã khu vực',
    curCountry: 'Mã khu vực hiện tại',
    countrySelect: 'Chọn Mã khu vực khác',
    getCode: 'Mã xác thực',
    codePlace: 'Nhập mã xác thực',
};
export const trade = {
    navigate: {
        recharge: 'Nạp',
        activity: 'Trung tâm sự kiện',
        transaction: 'Báo cáo',
        online_service: 'Dịch vụ trực tuyến',
        knowledge: "Tâm thủ nên xem",
        withdrawal: "Rút tiền"
    },
    tab: {home: 'Trang chính', position: 'Giao dịch', market: 'Vị thế', me: 'Của tôi'},
    noData: {
        content: 'Mạng lưới kết nối hơi chậm, xin làm mới thử lại',
        reload: 'Tải lại',
        noData: 'Tạm thời không có dữ liệu!',
        noLogin: 'Hiện bạn chưa đăng nhập, hãy đăng nhập rồi có thể xem chi tiết!',
        goPosition: 'Đi giao dịch',
    },
    bannerTitle: 'Giới thiệu có quà',
    bottom: {
        explain: "Nâng cấp hưởng ưu đãi",
        login: 'Đăng nhập/Đăng ký'
    },
    openIM: 'Nhân viên Dịch vụ trực tuyến',
    goHome: 'Trở về trang chính',
    token: "Đang đồng bộ trạng thái đăng nhập...",
    turn: 'Đang tải dữ liệu...',
    loading: 'Đang tải dữ liệu...',
    charts: {
        timeSharing: 'TG',
        fiveM: '5 phút',
        fifteenM: '15 phút',
        thirtyM: '30 phút',
        OneH: '1 tiếng',
        day: 'Ngày',
        time: "Thời gian",
        opens: 'Mở',
        highs: 'Cao',
        lows: 'Thấp',
        receipts: 'Thu'
    },
    products: {
        aboutNews: 'Tin tức liên quan',
        tradeProduct: 'Sản phẩm giao dịch',
        type: 'Loại hình',
        notSet: 'Chưa cài đặt',
        ask: 'Giá bán',
        bid: 'Giá mua',
        newP: 'Giá mới nhất',
        rate: "Biên độ tăng xuống",
        rise: 'Tăng',
        buy: 'Mua',
        fall: 'Giảm',
        sell: 'Bán',
        open: 'Mở',
        high: 'Cao nhất',
        low: 'Thấp nhất',
        newPs: 'Đóng',
        day: 'Ngày',
        dayWeek: 'Có hiệu trong ngày',
        week: 'Tuần',
        validWeek: 'Có hiệu trong tuần',
        marketPrice: 'Giá trị trường',
        pendingOrder: 'Đặt lệnh chờ',
        modifyPendingOrder: 'Sửa đặt lệnh chờ',
        positionOrder: 'Vị trí',
        limitPrice: 'Giá limit',
        justLoss: 'Cắt lỗ',
        amount: 'Vốn đầu tư',
        lot: 'Lot',
        price: 'Giá cả',
        money: 'Vốn',
        minAmount: 'Số tiền Min',
        stopLossSwitch: 'Cắt lỗ/Chốt lời',
        modifyStopLoss: 'Sửa cắt lỗ chốt lợi',
        stopProfit: 'Chốt lợi',
        stopProfitPrice: 'Giá chốt lợi',
        stopLoss: 'Cắt lỗ',
        stopLossPrice: 'Giá cắt lỗ',
        expectedProfit: 'Lãi dự tính',
        expectedLoss: ' Lỗ dự tính',
        validityPeriod: 'Thời hạn',
        reference: 'Qý quỹ tham khảo',
        available: "Vốn khả dụng",
        expectedProfitLoss: "Lãi lỗ dự tính",
        floatProfitLoss: 'Mức thay đổi lãi lỗ',
        realTimeProfitLoss: 'Lãi lỗ thực thời',
        finalPrice: 'Giá giao dịch',
        openingPosition: 'Mở vị trí',
        closePosition: 'Đóng vị trí',
        openingBuy: 'Mở và mua',
        openingSell: 'Mở và bán',
        executeBuy: 'Đóng và mua',
        executeSell: 'Đóng và bán',
        marketPriceSuc: 'Giao dịch với giá thị trường',
        limitPriceSuc: 'Giao dịch với giá limit',
        justLossSuc: 'Giao dịch với giá cắt lỗ',
        stopLossExecute: 'Đóng vị trí cắt lỗ',
        stopProfitExecute: "Chốt lợi đúng vị trí",
        systemExecute: "Hệ thống đóng vị trí",
        groupClose: 'Đóng vị trí giao dịch',
        tradeRecord: 'Xem lịch sử mua bán',
        entrustRecord: 'Xem lịch sử lệnh đặt',
        profitAndLossRecord: 'Xem lịch sử lãi lỗ',
        creditRecord: 'Xem lịch sử thay đổi tiền vốn',
        withdrawal: 'Hủy lệnh',
        transactionDay: 'GD/ngày',
        ProfitLossDay: 'Lợi Lỗ/ngày',
        more: 'More',
        rangeScope: 'Độ lệch tối đa',
        marginUsage: 'Ký quỹ đã dùng',
        availableMargin: 'Ký quỹ khả dụng'
    },
    attribute: 'Thuộc tính hợp đồng',
    unit: "Đơn vị hợp đồng",
    baseCurrency: 'Đơn vị tiền tệ',
    incomeCurrency: 'Tiền tệ thu lợi',
    quoteDigits: 'Số thập phân báo giá',
    spread: 'Chênh lệch',
    float: 'Không ổn định',
    singleTrade: 'Số lot giao dịch mỗi lần',
    minDistant: 'Khoảng cách lệnh chờ tối thiểu',
    singlePip: 'Khoảng cách mỗi lot',
    initialMargin: 'Ký quỹ ban đầu',
    holidayMargin: 'Ký quỹ ngày nghỉ',
    hedgingMargin: "Ký quỹ Hedging",
    three_day: '3 ngày lãi suất',
    tradingHours: 'Thời gian giao dịch',
    expiryTime: 'Thời gian thanh toán',
    USD: 'USD',
    lot: 'lot',
    amountRange: "Phạm vi số tiền đầu tư",
    totalOrder: 'của tổng ký qỹ đơn hàng hedging',
    requirement: 'Nhu cầu về ký quỹ',
    expirationTime: 'Thời hạn hợp động',
    DayOfWeek: {
        monday: 'Thứ 2',
        tuesday: 'Thứ 3',
        wednesday: 'Thứ 4',
        thursday: ' Thứ 5',
        friday: 'Thứ 6',
        saturday: 'Thứ 7',
        sunday: 'Chủ nhật',
        everyday: 'Hàng ngày'
    }
};
export const recharge = {
    feeInfo: 'Về phí thủ tục',
    feeExplain: "Xin lưu ý: Hãy chọn đúng số tiền khả dụng của thẻ nạp mà bạn đã mua, nếu không tiền vốn sẽ khó vào tài khoản",
    recharge_success: 'Chúc mừng nạp tiền thành công',
    recharge_fail: 'Nạp tiền xảy ta lỗi, hãy thử lại lần nữa.',
    toConfirm: 'Đang chờ xác nhận',
    pend: 'Đang chờ xét duyệt',
    approve: 'Đã xét duyệt',
    succ: 'Nạp tiền thành công',
    cancle: 'Hủy',
    noUpload: 'Chưa tải lên giấy phép',
    over: 'Quá hạn',
    Replenishment: 'Tải lên biên lai chuyển tiền',
    rechargeWay: 'Cách thanh toán',
    cardPay: 'Thanh toán bằng thẻ điểm',
    seller: 'Nhà cung cấp',
    cardMoney: 'Số tiền thẻ(VND)',
    rechargeMoney: 'Số tiền nạp (VND)',
    fee: 'Phí thủ tục（VND）',
    againCon: 'Xin xác nhận lại thông tin của thẻ',
    cardNum: 'Số thẻ',
    password: 'Mật khẩu nạp',
    typeNum: 'Xin nhập vào mật khẩu nạp',
    typePassword: 'Xin nhập vào mật khẩu nạp',
    payNow: 'Thanh toán ngay',
    cardText: 'Số thẻ của thẻ nạp bạn đã mua',
    passwordText: 'Mật khẩu nạp của thẻ nạp mà bạn đã mua',
    transferCopy: 'Sao chép',
    transferSucc: 'Sao chép thành công',
    goCharge: 'Đi rút tiền',
    details: "Chi tiết",
    transferNotice: 'Chú ý',
    transferDeposit: 'Gửi tiền Số tiền',
    tranferDe: 'Thông tin gửi tiền',
    supplyNum: 'Số hiệu xin',
    rechargeMethod: 'Cách nạp tiền',
    rechargeTime: 'Thời gian nạp tiền',
    transferBank: 'Ngân hàng gửi tiền',
    transferAdd: 'Địa chỉ chi nhánh',
    transferReci: 'Người nhận tiền',
    transferAcc: ' Số tài khoản',
    transferNote: 'Chú thích',
    deposited: "đã gửi tiền thành công",
    onlinebank: 'Ngân hàng trên mạng ',
    atm: "ATM",
    counterDeposit: 'Nạp tiền quầy',
    other: 'Cách khác',
    arrival: 'Số tiền nhận được',
    rechargeAcc: 'Số tiền nạp',
    rechargeSucc: 'Giấy phép nạp đã gửi thành công, hệ thống sẽ xử lý nhanh',
    trade: 'Trải nghiệm giao dịch',
    checkRecode: 'Xem lịch sử',
    copyMessages: "Trình duyệt này không thể tự động sao chép",
    amountPlaceholder: "Xin nhập vào số tiền",
    minAmountVND: "Nạp tiền thấp nhất",
    minAmountUSD: "Thấp nhất",
    tranferNoticeDetail: 'Đề nghị bạn hoàn thành gửi tiền trong 60 phút, nếu không thì lệnh  có thể không còn hiệu lực.Để đảm bảo việc nạp tiền thành công, vui lòng xác nhận số tiền chuyển khoản và số tiền hiển thị trong lệnh nạp là như nhau （phí chuyển khoản người chuyển trả)',
    submitTransferInfo: 'Để đảm bảo tiền vốn về tài khoản nhanh, bạn phải quay về trang này sau khi chuyển khoản thành công hoặc trang lịch nạp tiền để bổ sung giấy phép chuyển khoản',
    radio: 'Tỷ giá hiện thực là',
    pre: 'dự kiến',
    detail: ' cụ thể sẽ lấy số tiền nhận được làm tiêu chuẩn',
    rechargeTxt:"Số tiền nạp mỗi lần nhiều nhất：999999900.00 VND"
};
export const myself = {
    clickLogin: 'Ấn vào đăng nhập',
    uncomplate: 'Thông tin chưa đầy đủ',
    underReview: 'Đang xét duyệt',
    complate: 'hoàn thiện thành công',
    fali: 'Xét duyệt thất bại',
    balance: " Tiền dư của tôi(USD)",
    withdrawRecode: 'Chi tiết nạp tiền',
    recharge: 'Nạp tiền',
    withdrawal: 'Rút tiền',
    setPassword: 'Quản lý mật khẩu',
    myBankCard: 'Thẻ ngân hàng của tôi',
    add: 'Thêm',
    addBankCard: 'Thêm thẻ ngân hàng',
    tradeReport: 'Lịch sử báo cáo',
    messageCenter: 'Trung tâm thông tin',
    openIM: 'Liên hệ nhân viên CSKH',
    deleteUser: 'Thoát khởi',
    bankPopup: "Để bảo hộ an toàn vốn đầu tư của bạn, trước khi rút tiền, bạn cần kích hoạt tài khoản và liên kết thẻ ngân hàng.",
    realName: 'Đi kích hoạt'
};
export const message = {
    point: "Gợi ý",
    submit: 'Đưa ra',
    submitting: 'Đang đưa lên',
    cancel: 'Hủy bỏ',
    definite: 'Xác nhận',
    register: 'Đăng nhập lại',
    info_register: 'Xin lỗi, tài khoản này đã đăng nhập trên thiết bị khác!',
    info_tokenErr: "Thông tin đăng nhập hết hạn",
    modify: 'Xác nhận sửa lại',
    definiteClosing: 'Xác nhận đóng vị trí',
    info_withdrawal: 'Bạn xác nhận sẽ hủy đơn hàng này không？',
    withdrawalSuc: 'Hủy đơn thành công',
    info_noLogin: 'Chào bạn, du khách không thể tiến hành giao dịch, nếu cần nhiều phục vụ, xin vui lòng đăng ký hoặc đăng nhập đã',
    modifyStopLoss: {
        noModification: 'Không có bất cứ tham số nào sửa đổi, xin đưa lên sau khi bạn đã sửa đổi',
        stopLossNoRange: 'Cắt lỗ bạn nhập vào không trong phạm vi, xin nhập vào lại',
        stopProfitNoRange: 'Chốt lợi bạn nhập vào không trong phạm vi, xin nhập vào lại',
        priceNoRange: 'Giá cả bạn nhập vào không trong phạm vi, xin nhập vào lại',
        amountNoRange: 'Số tiền bạn nhập vào không có trong phạm vi, xin nhập lạ',
        insufficientFunds: "Tiền vốn khả dụng của bạn không đủ, xin nạp tiền kịp",
        maxAmount: 'Số tiền lớn nhất có thể đầu tư  là',
        integerAmount: "Số nhập vào phải là số lần chỉnh của"
    },
    insufficientBalance: "Chào quý khách, Số tiền dư của bạn không đủ",
    insufficientBalance_1: 'Để không ảnh hưởng đến giao dịch của bạn, xin nạp vào vốn kịp',
    poorNetwork: 'Mạng bị lỗi, xin vui lòng thử lại',
    info_dome: "Chào bạn, bạn cần chuyển sang tài khoản thật mới có thể thao tác",
    info_dome1: "Xin chuyển sang tài khoản thật, rồi mới có thể nạp tiền giao dịch",
    accountSwitch: "Chuyển sang tài khoản thật",
    demo: "Demo",
    real: "Thật",
    experienceDemo: ' Trải nghiệm demo'
};
export const success = {
    success: 'Thành công',
    congratulation: 'Chúc mừng bạn',
    infoTit_1: 'Chúc mừng, bạn đã sửa đổi cắt lỗ chốt lợi thành công！',
    infoTit_2: 'Chúc mừng, bạn đã đóng vị trí thành công！',
    viewPositions: 'Xem vị trí giữ',
    viewRecord: 'Xem lịch sử',
    viewProfitLoss: 'Xem Lợi Lỗ',
    startTrading: 'Bắt đầu giao dịch',
    positionID: 'Số thứ tự vị trí',
    orderID: "Số thứ tự đơn hàng",
    pendingID: 'Số thứ tự lệnh chờ',
    positionPro: 'Sản phẩm giữ vị trí',
    pendingPro: 'Sản phẩm lệnh chờ',
    executePrice: 'Giá đóng vị trí',
    openingPrice: 'Giá mở vị trí',
    openingTime: 'Thời gian mở vị trí',
    pendingPrice: 'Giá GD',
    pendingTime: 'Thời gian lệnh chờ',
    productDirection: ' Phương hướng sản phẩm',
    executeDirection: 'Phương hướng đóng',
    openingDirection: 'Phương hướng mở',
    pendingDirection: 'Phương hướng lệnh chờ',
    executeAmount: 'Số tiền đóng vị trí',
    profitLoss: 'Lãi lỗ',
    swap: 'Lãi qua đêm',
    interest: 'Lãi',
    commission: 'Hoa hồng',
    netProfitLoss: 'Lãi lỗ ròng',
    marketOpening: 'Mở với thị giá',
    pendingModify: 'Sửa đổi lệnh chờ',
    pendingType: 'Loại hình lệnh chờ',
    pageExpired: ' Trang đã mất hiệu',
};
export const webUiError = {
    negativeOne: "Tham số vô hiệu",
    error1: 'Sai mật khẩu',
    error2: 'Xin nhập đúng mã xác nhận',
    error4: 'Không có quyền thao tác',
    error5: 'Thao tác thất bài',
    error12: 'Tài khoản đã tổn tại',
    error13: 'Xin nhập vào số tài khoản đúng',
    error14: 'Xin lỗi, tài khoản này đã đăng nhập trên thiết bị khác!',
    error15: 'Tài khoản Demo đã quá hạn, xin mở tài khoản thật',
    error16: 'Xin nhập đúng số tài khoản',
    error17: 'Tài khoản đã tổn tại',
    error18: 'Xin lỗi, tài khoản này đã đăng nhập',
    error19: 'Lỗi kết nối mạng lưới, xin thử lại sau',
    error24: 'Tạm thời chưa có lịch sử liên quan',
    error38: 'Lỗi hệ thống, xin thử lại sau',
    error39: 'Tiền margin không đủ, để không ảnh hưởng đến giao dịch của bạn, xin kịp thời nạp vốn vào',
    error50: 'Tình hình thị trường tham khảo, không cung cấp phục vụ giao dịch',
    error54: 'Hệ thống đang xử lý, xin chờ đợi',
    error55: 'Đơn hàng đã thành công',
    error56: 'Trạng thái đơn hàng lỗi',
    error59: 'Giao dịch thành công',
    error62: 'Giá cả đã có thay đổi, xin đặt lệnh lại',
    error64: 'Đã vượt qua số lot hiệu quà trong 1 đơn giao dịch',
    error65: 'Thấp hơn số lot hiệu quà trong 1 đơn giao dịch ',
    error67: 'Số lot đóng vị trí đã vượt qua số lot giữ vị trí',
    error70: 'Không có vị trí có thể đóng',
    error73: 'Phạm vi điểm số pip thay đổi của giá cao nhất',
    error74: 'Xin lỗi, đã vượt qua số pip giữ vị trí nhiều nhất',
    error75: 'Không phải thời gian giao dịch, thao tác vô hiệu',
    error83: 'Số đơn đặt lệnh lớn nhất {0}đơn',
    error87: 'Tài khoản này có lỗi, xin liên hệ nhân viên CSKH liên quan',
    error89: 'Xin nhập vào số pip hiệu quà. Số pip hiệu quà là nguyên bội số của {0}',
    error94: 'Sản phẩm này đã tạm dựng giao dịch',
    error96: 'Tài khoản này chỉ có thể tiến hành thao tác đóng vị trí, nếu có thắc mắc, xin liên hệ nhân viên CSKH liên quan',
    error103: 'Vượt qua giới hạn vị trí giữ',
    error104: 'Sản phẩm đã hết hạn',
    error107: 'Cài đặt cắt lỗ chốt lợi sai',
    error108: 'Sản phẩm này chỉ có thể tiến hành thao tác đóng vị trí, nếu có thắc mắc xin liên hệ nhân viên CSKH liên quan',
    error110: 'Lỗi server, xin thử lại sau',
    error112: 'Không có quyền lực'
};
export const category = {
    Commodites: "Commodites",
    Forex: "Forex",
    Index: "Index",
    USStock: "USStock",
    HKStock: "HKStock",
    Crypto: "Crypto"
};
